<script setup>
import ApiTokenManager from '@/Pages/API/Partials/ApiTokenManager.vue';
import { pageTitle, containerGapForForm } from '@/Composables/PageMeta';
pageTitle.value = 'API Tokens';
containerGapForForm(); 
</script>

<template>
    <!-- <AppLayout title="API Tokens"> -->
        <div>
            <div>
                <ApiTokenManager/>
            </div>
            <div class="py-10"></div>
        </div>
    <!-- </AppLayout> -->
</template>
